<template>
    <div id="reporte_facturas_afn" >
      <div>
        <v-breadcrumbs :items="breadcrumbs" >
          <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
      </div>
    
      <v-container fluid fill-height>
        <v-row align-center justify-center>
          <v-col sm="12" >
            <base-material-card color="primary" icon="library_books" title="Reporte de Facturas Activo Fijo Nacional" class="elevation-1 px-5 py-3" >
              <br>
              <v-tabs grow style="margin-bottom: 30px;" >
                <v-tabs-slider color="primary" ></v-tabs-slider>
                <v-tab :key="'in-view'" >Vista Previa</v-tab>
                <v-tab :key="'in-report'" >Generar en Reporte</v-tab>
    
                <v-tab-item :key="'in-view'" >
                  <v-card-text>
                    <v-card-title>
                      <span class="headline" ></span>
                    </v-card-title>
                    <v-form ref="form1" lazy-validation>
                      <v-container grid-list-md text-xs-center>
                        <v-row row wrap>
                          <v-col sm="12" md="4" lg="4" >
    
                            <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                              <template v-slot:activator="{ on }" >
                                <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaDias, validaFecha]" >
                                </v-text-field>
                              </template>
    
                              <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu3 = false" >
                                <v-spacer />
    
                                <v-btn color="secondary" x-small @click="menu3 = false" >
                                  Cancelar
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col sm="12" md="4" lg="4" >
                            <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                              <template v-slot:activator="{ on }" >
                                <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaDias, validaFecha]" ></v-text-field>
                              </template>
                              <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu4 = false" >
                                <v-spacer />
    
                                <v-btn color="secondary" x-small @click="menu4 = false" >
                                  Cancelar
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
    
                          </v-col>
                          <v-col sm="12" md="4" lg="4" >
                            <v-autocomplete v-model="model.tipo_fecha" :items="arr_tipos_fechas" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Fecha" :rules="[rules.required]" >
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
    
                    <v-btn rounded color="success" @click="get_data_view()" :loading="loading" >
                      <v-icon>done</v-icon>Vista Previa
                    </v-btn>
                  </v-card-actions>
                  <v-card-text>
    
                          <v-client-table ref="vuetable" :data="data_view.datos" :columns="data_view.columns" :options="data_view.options" class="elevation-2 pa-2 scroll-table" >
                            <template slot="noResults" >
                              <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                            </template>

                            <template slot="importe" slot-scope="props" >
                                ${{(parseFloat(props.row.importe)).toFixed(2)}}
                            </template>
    
                            <template slot="actions_view" slot-scope="props" >
                              <v-speed-dial :id="props.row.id" direction="left" open-on-hover :style="'text-align:center;'" >
                                <template v-slot:activator>
                                  <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                  </v-btn>
                                </template>
    
                                <v-btn x-small fab dark color="green" v-if="props.row.type=='zip'" @click="downloadFile(props.row.key)" title="XML Factura" v-tippy>
                                  <v-icon>code</v-icon>
                                </v-btn>
                                <v-btn x-small fab dark color="red" v-if="props.row.pdf == 1" @click="downloadFile(props.row.key, 'pdf')" title="PDF Cove" v-tippy>
                                  <v-icon>picture_as_pdf</v-icon>
                                </v-btn>
    
                              </v-speed-dial>
                            </template>
                          </v-client-table>
    
                  </v-card-text>
    
                </v-tab-item>
                <v-tab-item :key="'in-report'" >
                  <v-card-text>
                    <v-card-title>
                      <span class="headline" ></span>
                    </v-card-title>
                    <v-form ref="form" lazy-validation>
                      <v-container grid-list-md text-xs-center>
    
                        <v-row row wrap>
                          <v-col sm="12" md="4" lg="4" >
                            <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                              <template v-slot:activator="{ on }" >
                                <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" >
                                </v-text-field>
                              </template>
    
                              <v-date-picker v-model="model.fecha_de" color="secondary"  scrollable locale="es-mx" @input="menu1 = false" >
                                <v-spacer />
    
                                <v-btn color="secondary" x-small @click="menu1 = false" >
                                  Cancelar
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col sm="12" md="4" lg="4" >
                            <v-menu offset-x  ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                              <template v-slot:activator="{ on }" >
                                <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[rules.required, validaAnio, validaFecha, $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)]" ></v-text-field>
                              </template>
                              <v-date-picker v-model="model.fecha_a" color="secondary"  scrollable locale="es-mx" @input="menu2 = false" >
                                <v-spacer />
    
                                <v-btn color="secondary" x-small @click="menu2 = false" >
                                  Cancelar
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
    
                          </v-col>
                          <v-col sm="12" md="4" lg="4" >
                            <v-autocomplete v-model="model.tipo_fecha" :items="arr_tipos_fechas" :hide-no-data="true" :return-object="false" item-text="text" item-value="id" label="Tipo de Fecha" :rules="[rules.required]" >
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
    
                    <v-btn color="success" @click="generar_reporte_sqs" :loading="loading" >
                      <v-icon>done</v-icon>Generar Reporte
                    </v-btn>
                  </v-card-actions>
    
                  <v-card-text>
                    <v-refresh-button :funcion="cargar" />
                    <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                      <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                      </template>
    
                      <template slot="actions" slot-scope="props" >
                        <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadReporte(props.row.filename)" >
                          <v-icon dark>get_app</v-icon>
                        </v-btn>
                        <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                          <v-icon dark>delete</v-icon>
                        </v-btn>
                      </template>
                    </v-client-table>
                  </v-card-text>
                </v-tab-item>
              </v-tabs>
            </base-material-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    </template>
    
    <script>
    import axios from "axios";
    import moment from "moment";
    import RefreshButton from "@/components/RefreshButton.vue";
    export default {
        components: {
            "v-refresh-button": RefreshButton,
        },
      created: function() {
        this.URL = this.$hostname + "reportes/";
        this.loading = false;
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.model.rfc = this.$local_storage.get("rfc");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario=="Soporte" || tipoUsuario=="Super Usuario")
            this.permisoEliminar = true;
        this.cargar();
      },
      data: () => ({
        permisoEliminar: false,
        tab: null,
        fab: false,
        breadcrumbs: [{
            text: "Inicio",
            disabled: false,
            to: "/home"
          },
          {
            text: "Facturas Activo Fijo Nacional",
            disabled: true,
            to: ""
          }
        ],
        datos: [],
        columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
        options: {
          filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
          sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
    
          headings: {
            id: "No. Proceso",
            fecha_solicitud: "Solicitado",
            usuario_email: "Usuario",
            nombre_reporte: "Reporte",
            criterio: "Criterio de Búsqueda",
            fecha_generacion: "Generado",
            estatus: "Estatus",
            error: "Error",
            actions: "Descargar"
          }
        },
        loading: false,
        show_loading: true,
        model: {
          rfc: "",
          usuario: "",
          fecha_de: "",
          fecha_a: "",
          reporte_url: "/reportes/facturas_afn/",
          nombre_reporte: "Facturas AFN",
          tipo: "Facturas AFN",
          tipo_reporte: "",
          tipo_operacion: "",
          tipo_fecha:"fecha_creado",
          archivo: "",
          pedimento: "",
          lista: "",
          busqueda: 1,
        },
        arr_tipos_fechas:[
          {"id":"fecha_creado", "text":"Fecha de Carga"},
          {"id":"fecha_factura", "text":"Fecha de Factura"},
        ],
        menu1: false,
        menu2: false,
        menu3: false,
        menu4: false,
        rules: {
          required: v => !!v || "Este campo es requerido",
          numeric: value => {
            const pattern = /^[\d]*$/;
            return pattern.test(value) || "Solo se permiten números";
          }
        },
        data_view: {
          datos: [],
          resumen: [],
          columns: [
            "fecha",
            "usuario",
            "archivo",
            "rfc",
            "folio",
            "fecha_emision",
            "tipo_cfdi",
            "importe",
            "actions_view"],
          options: {
            filterable: [
                "fecha",
                "usuario",
                "archivo",
                "rfc",
                "folio",
                "fecha_emision",
                "tipo_cfdi",
            ],
            sortable: [],
    
            headings: {
                fecha: "Fecha",
                usuario: "Usuario",
                archivo: "Archivo",
                rfc: "RFC",
                descripcion: "Tipo de Documento",
                folio: "Folio",
                fecha_emision: "Fecha Emision",
                tipo_cfdi:"Tipo CFDI",
                importe:"Importe",
                actions_view: 'Opciones'
            }
          },
        }
      }),
      methods: {
        validaFecha: function(fecha){
                 if (fecha == "Invalid date")
                    return "Fecha no válida.";
                else
                  return true;
        },
        validaAnio: function() {
          if (this.model.fecha_de != "" && this.model.fecha_a != "") {
            var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
            var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
            var diferencia = fin.diff(inicio, 'days')
            if (diferencia < 0)
              return "La Fecha Final no debe ser menor a la Fecha Inicial.";
          }
          return true;
        },
        validaDias: function() {
          if (this.model.fecha_de != "" && this.model.fecha_a != "") {
            var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
            var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
            var diferencia = fin.diff(inicio, 'days')
            if (diferencia < 0)
              return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            if (Math.abs(diferencia) > 366)
              return "Periodo máximo de consulta un año. Favor de verificar.";
          }
          return true;
        },
        cargar: function() {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          let data = {
            rfc: this.model.rfc,
            tipo: this.model.tipo
          };
          axios.post(this.URL + "get_reportes/", data)
            .then(res => {
              if (typeof res.data !== "undefined") {
                this.datos = res.data;
                this.datos.sort(function(a, b) {
                  //Ordenar por fecha más reciente
                  return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                });
                for (var k in this.datos) {
                  this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                  this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                  this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                  this.datos[k].criterio = this.getCriterioPredeterminados(this.datos[k].criterio);
                }
              }
            })
            .catch(err => {
              console.log(err);
            }).then(() => {
              this.$root.$dialogLoader.hide();
            });
        },
        getEstatus: function(estatus) {
          var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
          if (estatus in arr_estatus)
            return arr_estatus[estatus];
          else
            return "N/A";
        },
        getCriterioPredeterminados: function(criterio) {
          try {
            if (criterio != undefined && criterio.toString().trim() != "") {
                var params = JSON.parse(criterio);
                return "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;
            } else {
              return "N/A";
            }
          } catch (error) {
            console.log(error);
            return "N/A-error";
          }
    
        },
        get_data_view: function() {
          if (!this.$refs.form1.validate()) {
            //Alguna operación o mensaje
          } else {
            if (this.model.tipo_reporte == 4 && this.model.lista == '') {
              this.$swal({
                type: "info",
                title: "Información",
                text: "Debes ingresar al menos un elemento a la lista",
                footer: ""
              });
    
              return false;
            }
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var data = this.model;
            if (data.pedimento == '') delete(data['pedimento']);
            if (data.fecha_de == '') delete(data['fecha_de']);
            if (data.fecha_a == '') delete(data['fecha_a']);
            if (data.archivo == '') delete(data['archivo']);
            if (data.lista == '' || data.lista == []) {
              delete(data['lista'])
            } 
    
            axios({
                method: "post",
                url: "https://apireportes.econnectpro.mx/reportes/facturas_afn/",
                data: data
              })
              .then(response => {
                this.data_view.datos = response.data;
    
              })
              .catch(error => {
                let mensaje;
                if (typeof error.response !== "undefined") {
                  mensaje = error.response.data.mensaje;
                } else {
                  mensaje = "Reporte demasiado grande para vista previa. Intenta con un periodo más corto";
                }
    
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: mensaje,
                  footer: ""
                });
              }).then(() => {
                this.$root.$dialogLoader.hide();
              });
          }
        },
        generar_reporte_sqs() {
          if (!this.$refs.form.validate()) {
            //Alguna operación o mensaje
          } else {
            if (this.model.tipo_reporte == 4 && this.model.lista == '') {
              this.$swal({
                type: "info",
                title: "Información",
                text: "Debes ingresar al menos un elemento a la lista",
                footer: ""
              });
    
              return false;
            }
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var data = this.model;
            if (data.pedimento == '') delete(data['pedimento']);
            if (data.archivo == '') delete(data['archivo']);
            if (data.fecha_de == '') delete(data['fecha_de']);
            if (data.fecha_a == '') delete(data['fecha_a']);
            if (data.lista == '' || data.lista == []) {
              delete(data['lista'])
            } 
    
            axios({
                method: "post",
                url: this.$hostname + "reportes/save_reporte/",
                data: data
              })
              .then(response => {
                this.$swal({
                  type: "success",
                  title: "Operación Exitosa",
                  text: "El reporte se está generando. Cuando esté listo recibirás una notificación",
                  footer: ""
                });
              })
              .catch(error => {
                let mensaje;
                var titulo = "¡Operación no Permitida!";
                var tipo = "error";
                if (typeof error.response !== "undefined") {
                    mensaje = error.response.data.mensaje;
                    if (error.response.status == 406){
                        titulo = "¡Ya existe un reporte en proceso!";
                        tipo = "info";
                    }
                } else {
                    mensaje = "Ocurrió un error al generar el reporte";
                }
                this.$swal({
                    type: tipo,
                    title: titulo,
                    text: mensaje,
                    footer: ""
                });
              }).then(() => {
                this.cargar();
                this.$root.$dialogLoader.hide();
              });
          }
        },
        parseDate(date) {
          if (!date) return null;
          return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
          //Formato  YYYY-MM-DD
          if (!date) return null;
          return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
        clear_values() {
          this.model.pedimento = '';
          this.model.fecha_de = '';
          this.model.fecha_a = '';
          this.model.archivo = '';
        },
        base64ToArrayBuffer: function(base64) {
          var binaryString = window.atob(base64);
          var binaryLen = binaryString.length;
          var bytes = new Uint8Array(binaryLen);
          for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
          }
          return bytes;
        },
        downloadFile: function(key, tipo="xml") {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          if(tipo!="xml"){
            key = key.replace(".xml", "."+tipo);
            key = key.replace(".Xml", "."+tipo);
            key = key.replace(".XML", "."+tipo);
          }
          
          var datos = {
            id: key,
            bucket: "production.econnect.ds"
          }          
          
          let nombre_download = key.split("/").pop();
          /*axios.post(this.$hostname + "s3/download/", datos, {
              "Content-type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Allow: "POST",
              "cache-control": "no-cache",
            })
            .then(response => {
              var bytes = this.base64ToArrayBuffer(response.data);
              let blob = new Blob([bytes], {
                  type: response.headers["content-type"]
                }),
                url = window.URL.createObjectURL(blob);
    
              var a = document.createElement("a");
              document.body.appendChild(a);
              a.style = "display: none";
              a.href = url;
              a.download = nombre_download;
              a.click();
              a.parentNode.removeChild(a);
            })
            .catch(error => {
              console.log(error);
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                footer: ""
              });
            }).then(() => {
              this.$root.$dialogLoader.hide();
            });*/
          axios.post(this.$hostname + 's3/download_url/', datos)
            .then((res) => {
              if (typeof res.data !== 'undefined') {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = res.data.mensaje;
                a.target = '_blank';
                a.click();
                a.parentNode.removeChild(a);
    
              } else {
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                  footer: '',
                });
              }
            })
            .catch((error) => {
              var mensaje = "Ocurrió un error al descargar el archivo";
              if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                mensaje = error.response.data.mensaje;
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: mensaje,
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
            });
        },
        downloadReporte: function(key) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id: key,
            bucket: "production.econnect.ds"
          }
          axios.post(this.$hostname + 's3/download_url/', datos)
            .then((res) => {
              if (typeof res.data !== 'undefined') {
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = res.data.mensaje;
                a.target = '_blank';
                a.click();
                a.parentNode.removeChild(a);
    
              } else {
                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                  footer: '',
                });
              }
            })
            .catch((error) => {
              var mensaje = "Ocurrió un error al descargar el archivo";
              if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                mensaje = error.response.data.mensaje;
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: mensaje,
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
            });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
              if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();
                    });
              }
          });
        },
      },
    };
    </script>
    <style scoped>
    .theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
    .theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
    .theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
      color: black;
      font-size: small ;
      background-color: #EEEEEE;
      padding: 0px;
    }
    
    .v-tabs .v-tabs-bar .v-tab.v-tab--active {
      color: white;
      font-size: small ;
      background-color: #df7205;
      padding: 0px;
      font-weight: bold;
    
    }
    
    .v-tabs-slider-wrapper {
      left: 0 !important;
    }
    
    #tblcoves>>>thead th {
      white-space: nowrap !important;
    }
    
    .table-bordered thead th,
    .table-bordered thead td {
      font-size: x-small !important;
    }
    </style>
    